import axios from 'axios';
import config from '../../../config';

export const fetchProfiles = async (userId) => {
  try {
    const response = await axios.get(
      `${config.baseURL}/api/matches/friends-list`,
      {
        params: {
          user_id: userId
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching profiles:', error);
    throw error;
  }
};

export const fetchFilteredProfiles = async (userId, filters = {}) => {
  try {
    const response = await axios.get(
      `${config.baseURL}/api/matches/suggestions`,
      {
        params: {
          user_id: userId,
          ...filters
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching filtered profiles:', error);
    throw error;
  }
};